import React from 'react';
import { Input, Button, Spin } from 'antd';
import { Controller } from 'react-hook-form';
import { StyledForm, FormRow, Field, SubText } from './styled';
import { useSettingForm } from './hooks';
import { SettingTypes } from '.';
import LabelHoc from './LabelHoc';
import { validateWholeNumber } from './ValidationUtils';
import { getDisplayInterval } from '../AlertInsights/utils';

const DurationRangeMessage = 'Duration value should be between 1 and 30 days';

const IntervalInfo = ({ duration, hasError }) => {
  if (hasError) {
    return null;
  }

  const { to, from } = getDisplayInterval(Number(duration));
  return (
    <SubText>
      <div>{from} -</div>
      <div>{to}</div>
    </SubText>
  );
};

function Alert({ data = {} }) {
  const { control, handleSubmit, errors, mutation, onSubmit, readOnly, watch } = useSettingForm({
    data,
    type: SettingTypes.alertInsights,
  });

  const duration = watch('duration');
  const hasError = Object.values(errors).length > 0;

  return (
    <StyledForm onSubmit={handleSubmit(onSubmit)}>
      <Spin tip="Saving..." spinning={mutation.isLoading}>
        <FormRow>
          <LabelHoc text="Duration" err={errors.duration} />
          <Field>
            <Controller
              render={({ field }) => <Input addonAfter="days" {...field} readOnly={readOnly} />}
              name="duration"
              control={control}
              rules={{
                required: 'Duration is required',
                min: { value: 1, message: DurationRangeMessage },
                max: { value: 30, message: DurationRangeMessage },
                validate: validateWholeNumber,
              }}
            />
            <IntervalInfo duration={duration} hasError={errors.duration} />
          </Field>
        </FormRow>
        <FormRow>
          <LabelHoc text="Impacted Unique Devices" err={errors.impacted_unique_devices} />
          <Field>
            <Controller
              render={({ field }) => <Input addonBefore=">=" {...field} readOnly={readOnly} />}
              name="impacted_unique_devices"
              control={control}
              rules={{
                required: 'Impacted Unique Devices is required',
                min: { value: 1, message: 'Value should be greater than 0' },
                validate: validateWholeNumber,
              }}
            />
          </Field>
        </FormRow>
        <FormRow>
          <span />
          <Button disabled={readOnly || mutation.isLoading || hasError} htmlType="submit">
            Save
          </Button>
        </FormRow>
      </Spin>
    </StyledForm>
  );
}

export default Alert;
